/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Contract, ListCommandResult_Contract } from "@graphql/helpers/types.graphql";
import { CommandResult, ListCommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TClientType,
  TConcreteRecipeType,
  TConstructionType,
  TContractConcreteRecipeType,
  TContractSellerType,
  TContractType,
  TJoin,
  TNonEmptyArray,
  TSellerType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TContractType
  | TJoin<"construction", TConstructionType>
  | TJoin<"construction.client", TClientType>
  | TJoin<"contractConcreteRecipes", TContractConcreteRecipeType>
  | TJoin<"contractConcreteRecipes.concreteRecipe", TConcreteRecipeType>
  | TJoin<"contractSellers", TContractSellerType>
  | TJoin<"contractSellers.seller", TSellerType>;

type TContractByIdFunctions = {
  getByID: CommandResult_Contract;
};
export type TContractByIdQueries = {
  contract: TContractByIdFunctions;
};

export const contractById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query contractById($id: Guid!) {
    contract {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Contract")}
`;

type TContractAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_Contract;
};
export type TContractAllWithPaginationQueries = {
  contract: TContractAllWithPaginationFunctions;
};
export const contractAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    contract {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Contract")}
`;

type TContractAllWithSortedPaginationFunctions = {
  getAllWithSortedPagination: ListCommandResult_Contract;
};

export type TContractAllWithSortedPaginationQueries = {
  contract: TContractAllWithSortedPaginationFunctions;
};

export const contractAllWithSortedPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractAllWithSortedPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]) {
    contract {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Contract")}
`;
